import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';

interface IGetCampaignDiagnosticsUrlProps {
  customerId: string;
  accountId: string;
  campaignId: string;
  timeZoneId?: string | number;
  areas?: string[];
}

export const DiagnosticsAreas = {
  Campaign: 'Campaign',
  Editorial: 'EditorialStatus',
  Bidding: 'Bidding',
  AssetGroup: 'AssetGroup',
  Conversion: 'Conversion',
};

export interface IFetchCampaignDiagnosticsProps extends IGetCampaignDiagnosticsUrlProps {
  ccToken: string;
}

export function getCampaignDiagnosticsUrl({
  customerId,
  accountId,
  campaignId,
  timeZoneId = 71,
  areas = [DiagnosticsAreas.Campaign, DiagnosticsAreas.Editorial, DiagnosticsAreas.Bidding, DiagnosticsAreas.Conversion],
}: IGetCampaignDiagnosticsUrlProps) {
  const areasStr = areas.map((item) => `"${item}"`).join(',');
  return `${getOdataRootUrl()}/ODataApi/AdInsight/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/Recommendation.GetCampaignDiagnostics(timeZoneId=${timeZoneId},areas=[${areasStr}])`;
}

export function fetchCampaignDiagnostics({
  accountId,
  customerId,
  campaignId,
  ccToken,
  timeZoneId,
  areas,
}: IFetchCampaignDiagnosticsProps) {
  const url = getCampaignDiagnosticsUrl({
    customerId, accountId, campaignId, timeZoneId, areas,
  });

  return axios.get(url, {
    headers: {
      Authorization: ccToken,
    },
  } as AxiosRequestConfig);
}
